import { render, staticRenderFns } from "./presentation-editor-expand.vue?vue&type=template&id=78580c17&"
import script from "./presentation-editor-expand.vue?vue&type=script&lang=js&"
export * from "./presentation-editor-expand.vue?vue&type=script&lang=js&"
import style0 from "./presentation-editor-expand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports